<template>
  <!-- <svg
    viewBox="0 0 180 120"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style="margin: 0.5rem 1rem"
  >
    <path
      d="M89 0H174C176.761 0 179 2.23858 179 5V114C179 116.761 176.761 119 174 119H89V0Z"
      fill="#E3F5FC"
    />
    <path
      opacity="0.675"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M139.444 93.5005C137.491 95.4531 134.325 95.4531 132.373 93.5005L110.408 71.5355C108.455 69.5829 105.289 69.5829 103.337 71.5355L89 85.8721V119.053H113.891H157.925H173.688C178.176 119.053 180.392 113.598 177.174 110.469L152.98 86.9367C151.02 85.0302 147.892 85.0518 145.959 86.9853L139.444 93.5005Z"
      fill="#00ADE8"
    />
    <path
      opacity="0.675"
      d="M141.166 45.8266C135.654 45.8266 131.185 41.358 131.185 35.8457C131.185 30.3334 135.654 25.8649 141.166 25.8649C146.679 25.8649 151.147 30.3334 151.147 35.8457C151.147 41.358 146.679 45.8266 141.166 45.8266Z"
      fill="#00ADE8"
    />
    <rect x="16" y="65" width="63" height="16" rx="1" stroke="#00ADE8" stroke-width="2" />
    <rect x="16" y="40" width="63" height="16" rx="1" stroke="#00ADE8" stroke-width="2" />
    <rect x="15" y="14" width="65" height="5" rx="2.5" fill="#E3F5FC" />
    <rect x="33" y="24" width="29" height="5" rx="2.5" fill="#E3F5FC" />
    <rect x="15" y="89" width="65" height="18" rx="2" fill="#00ADE8" />
    <rect x="1" y="1" width="178" height="118" rx="4" stroke="#00ADE8" stroke-width="2" />
  </svg> -->
  <svg style="margin: 0.5rem 1rem" viewBox="0 0 180 120" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_1302_96983)">
      <path
        d="M178 5.95928C178 3.21906 175.593 1 172.624 1H92V119H172.624C175.593 119 178 116.781 178 114.041V5.95928Z"
        fill="#CCDCF3"
      />
      <path
        d="M158.244 67.0702C155.017 70.5053 151.941 73.7798 148.773 77.1526C138.266 66.5162 127.998 56.1224 117.54 45.5385C113.311 49.816 109.398 53.7919 105.459 57.7482C101.36 61.8683 97.1995 65.9328 93.1627 70.112C92.4997 70.8003 91.9968 71.9639 91.987 72.9144C91.8988 81.476 91.9347 110.245 91.9347 118.964H177.993C177.993 115.129 178.023 91.1684 177.954 87.4219C177.948 86.9728 177.484 86.4681 177.121 86.101C170.965 79.8765 164.792 73.6651 158.241 67.0735L158.244 67.0702Z"
        fill="#0059D5"
      />
      <path
        d="M154.423 19.6145C147.927 19.6735 142.59 25.1244 142.695 31.5817C142.802 38.0061 148.348 43.4144 154.723 43.3161C161.285 43.2112 166.471 37.7603 166.386 31.0605C166.305 24.6918 160.935 19.5555 154.42 19.6178L154.423 19.6145Z"
        fill="#0059D5"
      />
    </g>
    <rect x="16" y="65" width="63" height="16" rx="1" stroke="#0059D5" stroke-width="2" />
    <rect x="16" y="40" width="63" height="16" rx="1" stroke="#0059D5" stroke-width="2" />
    <rect x="15" y="14" width="65" height="5" rx="2.5" fill="#CCDCF3" />
    <rect x="33" y="24" width="29" height="5" rx="2.5" fill="#CCDCF3" />
    <rect x="15" y="89" width="65" height="18" rx="2" fill="#0059D5" />
    <rect x="1" y="1" width="178" height="118" rx="4" stroke="#0059D5" stroke-width="2" />
    <defs>
      <clipPath id="clip0_1302_96983">
        <rect width="86" height="118" fill="white" transform="matrix(-1 0 0 1 178 1)" />
      </clipPath>
    </defs>
  </svg>
</template>

<script setup></script>
